import Vue from 'vue'
import VueRouter from 'vue-router'
import About from './about.js'
import Qa from './qa.js'
import News from './news.js'
import Activities from './activities.js'
import Bigdata from './bigdata.js'
import store from '../store'
import { IS_SHOW_LOADING } from '../store/types'

import { setNavGation, ymTrack, goLogin, goAppHome } from '../utils/libs/native'

import { checkLogin } from '../utils/services/index.js'

const history = window.sessionStorage
history.clear()
let historyCount = history.getItem('count') * 1 || 0
history.setItem('/', 0)

Vue.use(VueRouter)

var routes = [
    {
        path: '/',
        name: 'home',
        component: (resolve) =>
            require.ensure([], () => resolve(require('../pages/home.vue')), 'home')
    },
    {
        path: '/pc',
        name: 'pc',
        component: (resolve) =>
            require.ensure([], () => resolve(require('../pages/pc/index.vue')), 'pc')
    },
    {
        path: '/wx',
        name: 'wx',
        component: (resolve) =>
            require.ensure([], () => resolve(require('../pages/wx.vue')), 'wx')
    },
    {
        path: '/download',
        name: 'download',
        component: (resolve) =>
            require.ensure([], () => resolve(require('../pages/download/index.vue')), 'download')
    },
    ...About,
    ...Qa,
    ...News,
    ...Activities,
    ...Bigdata
]

var router = new VueRouter({
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})

router.beforeEach((to, from, next) => {
    const toIndex = history.getItem(to.path)
    //const fromIndex = history.getItem(from.path);

    store.commit(IS_SHOW_LOADING, true)

    const { meta } = to

    // 设置页面标题
    if (meta.title) {
        setNavGation(meta.title)
    }

    if (!toIndex) {
        ++historyCount
        history.setItem('count', historyCount)
        to.path !== '/' && history.setItem(to.path, historyCount)
    }

    if (meta.track) {
        try {
            // 友盟埋点
            ymTrack(meta.track.evt, meta.track.label)
            // 百度埋点
            //trackPageView(to.fullPath);
        } catch (err) {}
    }

    // 是否要求登录态
    if (meta.auth) {
        checkLogin(Vue).then(
            (res) => {
                next()
            },
            (err) => {
                if (
                    err.data &&
                    (err.data.errorCode == 5001 ||
                        err.data.errorCode == 1012 ||
                        err.data.errorCode == 1011)
                ) {
                    goLogin(1).then(
                        (res) => {
                            window.location.reload()
                        },
                        () => {
                            goAppHome()
                        }
                    )
                } else {
                    if (err && err.errorMessage) {
                        Wui.Toast.show(err.errorMessage)
                    }

                    setTimeout(() => {
                        goAppHome()
                    }, 1000)
                }
            }
        )
    } else {
        next()
    }
})

router.afterEach(() => {
    Vue.nextTick(() => setTimeout(() => store.commit(IS_SHOW_LOADING, false)))
    Vue.nextTick(() => {
        window.scrollTo(0, 0)
    })
})

export default router



// WEBPACK FOOTER //
// ./src/routes/index.js